'use strict';

class AuthModel {
  constructor() {
    this.requestHeaders = {
      'Accept': 'application/json',
      'Content-type': 'application/json; charset=utf-8'
    }
  }
  request() {
    return fetch($AUTH_HOST + '/v1/users/me/checkout', {
      headers: this.requestHeaders,
      method: 'GET'
    })
  }
}

module.exports = AuthModel;
